import { RootState } from '@shared/model';

export const selectUserId = (state: RootState) => state.user.userId;
export const selectIsAuth = (state: RootState) => state.user.isAuth;
export const selectUserState = (state: RootState) => state.user;
